import React__default from 'react';
import { Icon } from '@sravni/react-design-system';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { User } from '@sravni/react-icons';
import { useStyles, useAuthLoginLink } from '@sravni/react-utils';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';
import modules_6ac6ab78 from '../styles/MobileLoginButton.module.less.js';

const MobileLoginButton = (props) => {
    const cx = useStyles(modules_6ac6ab78);
    const { oidcHandlerPrefix, authBannerUrl } = useCustomProps();
    const authLoginLinkProps = useAuthLoginLink({ prefix: oidcHandlerPrefix, isNewWindow: true, bannerUrl: authBannerUrl });
    return (React__default.createElement(Link, { ...props, ...authLoginLinkProps, className: cx('loginLink') },
        React__default.createElement(Icon, { className: cx('triggerButton'), size: 16, background: "light", icon: React__default.createElement(User, null) })));
};
MobileLoginButton.displayName = 'MobileLoginButton';

export { MobileLoginButton };
//# sourceMappingURL=MobileLoginButton.js.map
